(function () {
  var ERROR_GENERIC = 'Une erreur est survenue. Merci de réessayer.';
  var ERROR_NETWORK = 'Connexion impossible. Merci de réessayer dans un instant.';

  function bind(form) {
    if (form.__klaviyoBound) return;
    form.__klaviyoBound = true;

    var success = form.querySelector('[data-newsletter-success]');
    var error = form.querySelector('[data-newsletter-error]');
    var button = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (success) success.hidden = true;
      if (error) { error.textContent = ''; error.hidden = true; }
      if (button) button.disabled = true;

      var body = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { body.append(key, value); });

      fetch(form.action, {
        method: 'POST',
        credentials: 'omit',
        headers: {
          'Cache-Control': 'no-cache',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: body.toString()
      })
        .then(function (response) { return response.json().catch(function () { return null; }); })
        .then(function (json) {
          if (json && json.success) {
            if (success) success.hidden = false;
            form.reset();
            if (window.dataLayer) {
              window.dataLayer.push({ event: 'newsletter_signup', source: 'footer' });
            }
          } else {
            var message = ERROR_GENERIC;
            if (json && json.errors && json.errors.length) message = json.errors[0];
            if (error) { error.textContent = message; error.hidden = false; }
          }
        })
        .catch(function () {
          if (error) { error.textContent = ERROR_NETWORK; error.hidden = false; }
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    });
  }

  function boot() {
    var forms = document.querySelectorAll('form[data-klaviyo-form]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
